<template>
    <div id="beneficiario-errors-form-logs">
        <b-modal ref="beneficiario-errors-form" id="beneficiario-errors-form" hide-footer centered body-class="body-class container editar-beneficiario-form" size="lg" :visible="true"
		no-close-on-backdrop no-close-on-esc @hidden="close">
            <div class=" w-100 d-flex align-items-end justify-content-end mb-4">
				<b-button pill class="btn-base outline-primary-btn optum-bold" @click="downloadFileLog">Download log</b-button>
			</div>
            <b-form-textarea
            id="errors"
            v-model="errors"
            rows="3"
            max-rows="6"
            >
            </b-form-textarea>
        </b-modal>
    </div>
</template>
<script>
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"

export default {
	name: "ModalCorrigirErrosInesperadosLog",
	props: {
		row: {
            type: [Object, null],
            required: false,
            nullable: true,
        }
	},
	data() {
		return {
            errors: null
        }
	},
    methods: { 
        close() {
            this.$bvModal.hide('beneficiario-errors-form')
            this.$emit("closeErrors")   
        },
        downloadFileLog() {
            const blob = new Blob([JSON.stringify(this.errors)], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'log.txt');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    mounted() {
        if(this.row)
        {
            BeneficiarioImportacaoResource.getLineImportacao(this.row.id.importacaoId, this.row.id.line, {showLoader: true})
            .then(row => {
                if (row.errors) {
                    this.errors = JSON.parse(row.errors)
                }
            })
        }
    }
}
</script>